export const elements = {
    batteryCapacity: document.getElementById('batteryCapacity') as HTMLInputElement,
    efficiencySlider: document.getElementById('efficiencySlider') as HTMLInputElement,
    efficiencyVal: document.getElementById('efficiencyVal') as HTMLElement,
    currentSoCVal: document.getElementById('currentSoCVal') as HTMLElement,
    targetSoCVal: document.getElementById('targetSoCVal') as HTMLElement,
    socSlider: document.getElementById('socSlider') as HTMLElement,
    handleCurrent: document.getElementById('handleCurrent') as HTMLElement,
    handleTarget: document.getElementById('handleTarget') as HTMLElement,
    sliderFill: document.getElementById('sliderFill') as HTMLElement,
    togglePowerMode: document.getElementById('togglePowerMode') as HTMLElement,
    toggleText: document.getElementById('toggleText') as HTMLElement,
    kwSelector: document.getElementById('kwSelector') as HTMLElement,
    vaSelector: document.getElementById('vaSelector') as HTMLElement,
    presetContainer: document.getElementById('presetContainer') as HTMLElement,
    voltageText: document.getElementById('voltageText') as HTMLElement,
    customKwInput: document.getElementById('customKwInput') as HTMLElement,
    customKwValue: document.getElementById('customKwValue') as HTMLInputElement,
    inputVolts: document.getElementById('inputVolts') as HTMLInputElement,
    inputAmps: document.getElementById('inputAmps') as HTMLInputElement,
    departureTime: document.getElementById('departureTime') as HTMLInputElement,
    resEnergy: document.getElementById('resEnergy') as HTMLElement,
    resWallEnergy: document.getElementById('resWallEnergy') as HTMLElement,
    resHours: document.getElementById('resHours') as HTMLElement,
    resMins: document.getElementById('resMins') as HTMLElement,
    resDeparture: document.getElementById('resDeparture') as HTMLElement,
    resPlugTime: document.getElementById('resPlugTime') as HTMLElement,
    resPlugAMPM: document.getElementById('resPlugAMPM') as HTMLElement,
    vaResultKw: document.getElementById('vaResultKw') as HTMLElement,
    themeToggle: document.getElementById('themeToggle') as HTMLElement,
    themeIcon: document.getElementById('themeIcon') as HTMLElement
};
